import React from 'react'

const Loading = ({ Text, style }) => {
    return (
        <div className="loading" style={style}> 
            <span />
            <span />
            <span />
        </div>
    )
}

export default Loading